import React, { useState } from 'react';
import {
  Stack,
  Container,
  Typography,
  IconButton,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';
import Page from 'src/components/Page';
import { TabContext, TabPanel } from '@mui/lab';
import RecievedBookingRequest from 'src/components/ViewInvitationComponents/RecievedBookingRequest';
import SentBookingRequest from 'src/components/ViewInvitationComponents/SentBookingRequest';
import RecievedShipmentRequest from 'src/components/ViewInvitationComponents/RecievedShipmentRequest';
import SentShipmentRequest from 'src/components/ViewInvitationComponents/SentShipmentRequest';

export default function ViewInvites() {
  const navigate = useNavigate();
  const theme = useTheme();
  const userData = JSON.parse(localStorage.getItem('user'));
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check for mobile screen

  const [selectedTab, setSelectedTab] = useState(0); // State to handle the active tab
  const [selectedTabRECIEVEDREQ, setSelectedTabRECIEVEDREQ] = useState(0); // State to handle the active tab
  const [selectedTabSENTREQ, setSelectedTabSENTREQ] = useState(0); // State to handle the active tab

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
  };

  const handleTabChangeRECIEVEDREQ = (event, newValue) => {
    setSelectedTabRECIEVEDREQ(newValue); // Switch the tab based on user selection
  };
  const handleTabChangeSENTREQ = (event, newValue) => {
    setSelectedTabSENTREQ(newValue); // Switch the tab based on user selection
  };

  return (
    <Page title={`Invitations  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={0}>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Invitations
          </Typography>
        </Stack>

        {/* <TabContext value={selectedTab.toString()}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant={isMobile ? 'scrollable' : 'standard'} // Scrollable tabs for mobile
            scrollButtons={isMobile ? 'auto' : false} // Show scroll buttons if needed
            sx={{
              '& .MuiTab-root': {
                fontSize: isMobile ? '10px' : '12px', // Reduce font size on mobile
                minWidth: isMobile ? 'auto' : '160px', // Adjust width
                padding: isMobile ? '6px' : '12px'
              }
            }}
          >
            <Tab sx={{ fontSize: '12px' }} label={'RECIEVED REQUEST'} />
            <Tab sx={{ fontSize: '12px' }} label={'SENT REQUEST'} />
          </Tabs>

          <TabPanel value="0" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <TabContext value={selectedTabRECIEVEDREQ.toString()}>
              <Tabs
                value={selectedTabRECIEVEDREQ}
                onChange={handleTabChangeRECIEVEDREQ}
                indicatorColor="primary"
                textColor="primary"
                variant={isMobile ? 'scrollable' : 'standard'} // Scrollable tabs for mobile
                scrollButtons={isMobile ? 'auto' : false} // Show scroll buttons if needed
                sx={{
                  '& .MuiTab-root': {
                    fontSize: isMobile ? '10px' : '12px', // Reduce font size on mobile
                    minWidth: isMobile ? 'auto' : '160px', // Adjust width
                    padding: isMobile ? '6px' : '12px'
                  }
                }}
              >
                <Tab sx={{ fontSize: '12px' }} label={'TRUCK REQUEST'} />
                <Tab sx={{ fontSize: '12px' }} label={'SHIPMENT REQUEST'} />
              </Tabs>

              <TabPanel
                value="0"
                sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}
              >
                <RecievedBookingRequest />
              </TabPanel>
              <TabPanel
                value="1"
                sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}
              >
                <RecievedShipmentRequest />
              </TabPanel>
            </TabContext>
          </TabPanel>

          <TabPanel value="1" sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}>
            <TabContext value={selectedTabSENTREQ.toString()}>
              <Tabs
                value={selectedTabSENTREQ}
                onChange={handleTabChangeSENTREQ}
                indicatorColor="primary"
                textColor="primary"
                variant={isMobile ? 'scrollable' : 'standard'} // Scrollable tabs for mobile
                scrollButtons={isMobile ? 'auto' : false} // Show scroll buttons if needed
                sx={{
                  '& .MuiTab-root': {
                    fontSize: isMobile ? '10px' : '12px', // Reduce font size on mobile
                    minWidth: isMobile ? 'auto' : '160px', // Adjust width
                    padding: isMobile ? '6px' : '12px'
                  }
                }}
              >
                <Tab sx={{ fontSize: '12px' }} label={'TRUCK REQUEST'} />
                <Tab sx={{ fontSize: '12px' }} label={'SHIPMENT REQUEST'} />
              </Tabs>
              <TabPanel
                value={'0'}
                sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}
              >
                <SentBookingRequest />
              </TabPanel>
              <TabPanel
                value={'1'}
                sx={{ padding: '0px 0px 0px 0px ', marginTop: 2, marginBottom: 2 }}
              >
                <SentShipmentRequest />
              </TabPanel>
            </TabContext>
          </TabPanel>
        </TabContext> */}
        <TabContext value={selectedTab.toString()}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant={isMobile ? 'scrollable' : 'fullWidth'}
            scrollButtons={isMobile ? 'auto' : false}
            sx={{
              backgroundColor: '#f9f9f9',
              borderRadius: 2,
              p: 1,
              boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
              '& .MuiTab-root': {
                fontSize: isMobile ? '11px' : '13px',
                minWidth: isMobile ? 'auto' : '180px',
                borderRadius: '12px',
                fontWeight: 500,
                textTransform: 'none',
                mx: 0.5,
                transition: 'all 0.2s ease',
                '&:hover': {
                  backgroundColor: 'rgba(25, 118, 210, 0.1)'
                }
              },
              '& .Mui-selected': {
                fontWeight: 600,
                color: 'primary.main',
                backgroundColor: 'rgba(25, 118, 210, 0.15)'
              }
            }}
          >
            <Tab label="Received Request" />
            <Tab label="Sent Request" />
          </Tabs>

          {/* RECEIVED REQUEST PANEL */}
          <TabPanel value="0" sx={{ p: 0, mt: 2 }}>
            <TabContext value={selectedTabRECIEVEDREQ.toString()}>
              <Tabs
                value={selectedTabRECIEVEDREQ}
                onChange={handleTabChangeRECIEVEDREQ}
                indicatorColor="primary"
                textColor="primary"
                variant={isMobile ? 'scrollable' : 'fullWidth'}
                scrollButtons={isMobile ? 'auto' : false}
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  p: 1,
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  '& .MuiTab-root': {
                    fontSize: isMobile ? '11px' : '13px',
                    minWidth: isMobile ? 'auto' : '160px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 500,
                    mx: 0.5
                  },
                  '& .Mui-selected': {
                    fontWeight: 600,
                    backgroundColor: 'rgba(25, 118, 210, 0.1)'
                  }
                }}
              >
                <Tab label="Truck Request" />
                <Tab label="Shipment Request" />
              </Tabs>

              <TabPanel value="0" sx={{ p: 0, mt: 2 }}>
                <RecievedBookingRequest />
              </TabPanel>
              <TabPanel value="1" sx={{ p: 0, mt: 2 }}>
                <RecievedShipmentRequest />
              </TabPanel>
            </TabContext>
          </TabPanel>

          {/* SENT REQUEST PANEL */}
          <TabPanel value="1" sx={{ p: 0, mt: 2 }}>
            <TabContext value={selectedTabSENTREQ.toString()}>
              <Tabs
                value={selectedTabSENTREQ}
                onChange={handleTabChangeSENTREQ}
                indicatorColor="primary"
                textColor="primary"
                variant={isMobile ? 'scrollable' : 'fullWidth'}
                scrollButtons={isMobile ? 'auto' : false}
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: 2,
                  p: 1,
                  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                  '& .MuiTab-root': {
                    fontSize: isMobile ? '11px' : '13px',
                    minWidth: isMobile ? 'auto' : '160px',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 500,
                    mx: 0.5
                  },
                  '& .Mui-selected': {
                    fontWeight: 600,
                    backgroundColor: 'rgba(25, 118, 210, 0.1)'
                  }
                }}
              >
                <Tab label="Truck Request" />
                <Tab label="Shipment Request" />
              </Tabs>

              <TabPanel value="0" sx={{ p: 0, mt: 2 }}>
                <SentBookingRequest />
              </TabPanel>
              <TabPanel value="1" sx={{ p: 0, mt: 2 }}>
                <SentShipmentRequest />
              </TabPanel>
            </TabContext>
          </TabPanel>
        </TabContext>
      </Container>
    </Page>
  );
}
